__turbopack_context__.v({
  "voucherDialog": "TaxReturnVoucherDialog-module__kPxndG__voucherDialog",
  "voucherHeader": "TaxReturnVoucherDialog-module__kPxndG__voucherHeader",
  "voucherItem_Amount": "TaxReturnVoucherDialog-module__kPxndG__voucherItem_Amount",
  "voucherItem_Amount_Text": "TaxReturnVoucherDialog-module__kPxndG__voucherItem_Amount_Text",
  "voucherItem_DueDate": "TaxReturnVoucherDialog-module__kPxndG__voucherItem_DueDate",
  "voucherItem_Name": "TaxReturnVoucherDialog-module__kPxndG__voucherItem_Name",
  "voucherItem_Status": "TaxReturnVoucherDialog-module__kPxndG__voucherItem_Status",
});
